import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=5779529d&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=5779529d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779529d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5779529d')) {
      api.createRecord('5779529d', component.options)
    } else {
      api.reload('5779529d', component.options)
    }
    module.hot.accept("./addDialog.vue?vue&type=template&id=5779529d&scoped=true", function () {
      api.rerender('5779529d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/components/addDialog.vue"
export default component.exports